module.exports = __webpack_public_path__ + "img/img_phone_route.713a24ee.png";